import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=2b8759a4&scoped=true"
import script from "./advantages.vue?vue&type=script&lang=js"
export * from "./advantages.vue?vue&type=script&lang=js"
import style0 from "./advantages.vue?vue&type=style&index=0&id=2b8759a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8759a4",
  null
  
)

export default component.exports